<template>
  <div class="formula-wrap">
    <el-tabs tab-position="left" style="height: 100%;" v-if="containers.length > 0">
      <el-tab-pane v-for="(obj,key) in containers" :key="key" :label="obj.displayName">
        <div class="btn-content">
          <el-button icon="el-icon-plus" type="primary" @click="showVisible(key)">添加计量点</el-button>
        </div>
        <div class="table-content">
          <nk-table :showIndex="true" :data="obj.items" noDataTitle="该容器暂无测量点" :columns="columns">
            <el-table-column slot="operation" label="操作" width="200" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="delItem(key,scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </nk-table>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 新增测量点 -->
    <div>
      <el-dialog title="添加测量点" :visible.sync="visible" width="500px" :close-on-click-modal="false">
        <div style="padding: 6px;background: #00388c;color: #fff;" class="box1">
          对象列表：
          <el-select style="width:140px" size="mini" v-model="objId" @change="objChange">
            <el-option v-for="(item,index) in objData" :key="index" :value="item.id" :label="item.displayName"></el-option>
          </el-select>
          <el-input placeholder="输入关键字进行过滤" v-model="filterText" style="width:180px;margin-left:10px"></el-input>
        </div>

        <div style="width:100%;height:400px; overflow: auto;">
          <el-tree :data="treeData" node-key="id" :props="defaultProps" @node-click="nodeClick" :filter-node-method="filterNode" ref="tree"></el-tree>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import api from "@common/api/index.js";
import NkTable from "@/components/common/NkTable";
import tree from "@/utils/tree";
export default {
  components: { NkTable },
  props: {
    measureId: {
      type: String,
      default: "",
    },
  },
  watch: {
    measureId (val) {
      this.getData(val);
    },
    filterText (val) {
      this.$refs.tree.filter(val);
    },
  },
  data () {
    return {
      containers: [],
      columns: [
        { prop: "id", label: "测量点ID", show: true },
        { prop: "name", label: "测量点名称", show: true },
        { prop: "remark", label: "备注", show: true },
        { prop: "operation", slot: "operation", label: "操作", show: true },
      ],
      visible: false,
      selectKey: null,
      objData: [],
      objId: "",
      treeData: [],
      defaultProps: {
        children: "children",
        label: "measureName",
      },
      filterText: '',
    };
  },
  created () {
    this.getData(this.measureId);
  },
  methods: {
    filterNode (value, data) {
      if (!value) return true;
      return data.measureName.indexOf(value) !== -1;
    },
    getData (id) {
      let vm = this;
      api.measure
        .getDirectSubNode(id, JSON.stringify([]))
        .then((res) => {
          vm.containers = res.data;
        });
    },
    showVisible (key) {
      let vm = this;
      vm.getCompanyViewTreesInfo();
      vm.selectKey = key;
      vm.visible = true;
    },
    async getCompanyViewTreesInfo () {
      let vm = this;
      await api.view.getCompanyViewTreesInfo(this.$store.state.user.currentCompanyId).then((res) => {
        if (res) {
          vm.objData = res.data;
          if (res.data.length > 0) {
            vm.objId = res.data[0].id;
            vm.getViewTreeNodes(vm.objId);
          }
        }
      });
    },
    async getViewTreeNodes (id) {
      await api.view.getViewTreeNodes(id).then((res) => {
        let data = tree.creatTreeJson(res.data, 0);
        this.treeData = data;
      });
    },
    objChange (val) {
      this.getViewTreeNodes(val);
    },
    nodeClick (data) {
      let vm = this;
      vm.addItem(vm.selectKey, data);
    },
    delItem (key, index) {
      let vm = this;
      let items = JSON.parse(JSON.stringify(vm.containers[key].items));
      let delMeasureId = items[index].id
      items.splice(index, 1);
      // let ids = [];
      // for (let index = 0; index < items.length; index++) {
      //   const element = items[index];
      //   ids.push(element.id);
      // }
      api.measure
        .deleteItemsFromMeasureContainer(
          vm.measureId,
          vm.containers[key].name,
          JSON.stringify([delMeasureId])
        )
        .then((res) => {
          if (res.success) {
            vm.$message("删除成功！");
            vm.containers[key].items = items;
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    addItem (key, obj) {
      let vm = this;
      let items = JSON.parse(JSON.stringify(vm.containers[key].items));
      items.push({
        id: obj.measureId,
        name: obj.measureName,
        remark: obj.measureRemark,
      });
      let ids = [];
      for (let index = 0; index < items.length; index++) {
        const element = items[index];
        ids.push(element.id);
      }
      api.measure
        .addItemsToMeasureContainer(
          vm.measureId,
          vm.containers[key].name,
          JSON.stringify(ids)
        )
        .then((res) => {
          if (res.success) {
            vm.$message("添加成功！");
            vm.containers[key].items = items;
            vm.visible = false;
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
  },
};
</script>
<style lang="css" scoped>
.box1 >>> .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 30px;
  line-height: 30px;
  outline: 0;
  padding: 0 15px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}
</style>
<style lang="scss" scoped>
.formula-wrap {
  width: 90%;
  margin: 0px auto;
  height: 100%;
}

.btn-content {
  text-align: left;
  padding-bottom: 10px;
}
.table-content {
  height: calc(100% - 60px);
  padding-bottom: 10px;
}
</style>
